import React from 'react';

export default function SunglassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 28" fill="none" className={className}>
      {/* Bridge */}
      <path d="M16 14C17 10 23 10 24 14" stroke="#2C2419" strokeWidth="2" fill="none" />
      {/* Left lens */}
      <rect x="2" y="8" width="14" height="12" rx="4" fill="#2C2419" />
      <rect x="3" y="9" width="12" height="10" rx="3" fill="#4A3B30" opacity="0.8" />
      {/* Right lens */}
      <rect x="24" y="8" width="14" height="12" rx="4" fill="#2C2419" />
      <rect x="25" y="9" width="12" height="10" rx="3" fill="#4A3B30" opacity="0.8" />
      {/* Shine */}
      <path d="M6 11L10 11" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.4" />
      <path d="M28 11L32 11" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.4" />
      {/* Arms */}
      <path d="M2 12L-2 10" stroke="#2C2419" strokeWidth="2" strokeLinecap="round" />
      <path d="M38 12L42 10" stroke="#2C2419" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
